import { KYMW1108Component } from './kymw1108.component';

import type { GoodsInfo } from './vo/good-info.model';
import type { SelectableEBaseGoodsInfo } from './vo/selectable-ebase-goods-info.model';

/**
 * eBASE取込コンポーネントの値を管理するクラス
 *
 * @export KYMW1108Model
 * @class KYMW1108Model
 */
export class KYMW1108Model {
  kymw1108Component: KYMW1108Component;
  // 背景色(CommonSettingから取得した背景色)
  backgroundColor: string = getComputedStyle(document.documentElement).getPropertyValue('--contents-background-color');

  // 選択されているインデックス
  currentIndex: number = 0;
  // (画面に表示される) 取込先選択対象 eBASE取込データ一覧
  currentSelectableEBaseGoodsInfo: SelectableEBaseGoodsInfo = {} as SelectableEBaseGoodsInfo;
  // (画面に表示される) eBASE 取込商品候補一覧
  currentCandidateGoodsInfoList: GoodsInfo[] = [];
  // 選択されたeBASE 取込商品一覧と対応するJANコードのマッピングデータ
  selectedGoodsInfoListByJanCode: Map<string, GoodsInfo[]> = new Map<string, GoodsInfo[]>();
  // 取込ボタン非活性フラグ
  isDesabledImportButton: boolean = true;
}
